import { periodsOverlap } from './authorizationHoursTimeOptions';

export const WEEK_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const PERIOD_ERROR = {
  INVALID_PERIOD: 'invalidPeriod',
  OVERLAP_PERIODS: 'overlapPeriods',
  OVERLAP_REFERENCE: 'overlapReference',
};

const TIME_STEP_MINUTES = 10;
const LAST_START_TIME = '23:50';

export const buildTimeOptions = () => {
  const options = [];
  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += TIME_STEP_MINUTES) {
      const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      options.push({ value: timeString, label: timeString });
    }
  }
  return options;
};

export const TIME_OPTIONS = buildTimeOptions();

export const toApiWeekDay = (day) => day.charAt(0).toUpperCase() + day.slice(1);

export const cloneDayHours = (hours) => ({
  closed: hours.closed,
  periods: hours.periods.map((period) => ({ ...period })),
});

export const buildEmptyWeek = (defaultPeriod) => Object.fromEntries(
  WEEK_DAYS.map((day) => [day, { closed: true, periods: [{ ...defaultPeriod }] }]),
);

export const weekFromApi = (apiDays, defaultPeriod) => {
  const week = buildEmptyWeek(defaultPeriod);
  (apiDays || []).forEach((dayHours) => {
    const dayKey = String(dayHours.weekDay || '').toLowerCase();
    if (!week[dayKey] || !dayHours.periods?.length) {
      return;
    }
    week[dayKey] = {
      closed: false,
      periods: dayHours.periods.map((period) => ({ from: period.from, to: period.to })),
    };
  });
  return week;
};

export const weekToApi = (week) => WEEK_DAYS.map((day) => ({
  weekDay: toApiWeekDay(day),
  periods: week[day].closed ? [] : week[day].periods,
}));

export const periodsByDay = (apiDays) => {
  const map = {};
  (apiDays || []).forEach((dayHours) => {
    map[String(dayHours.weekDay || '').toLowerCase()] = dayHours.periods || [];
  });
  return map;
};

export const getPeriodsErrorCode = (periods, blockedPeriods = []) => {
  if (periods.some((period) => period.from >= period.to)) {
    return PERIOD_ERROR.INVALID_PERIOD;
  }

  const sorted = [...periods].sort((left, right) => left.from.localeCompare(right.from));
  for (let index = 0; index < sorted.length - 1; index += 1) {
    if (sorted[index].to > sorted[index + 1].from) {
      return PERIOD_ERROR.OVERLAP_PERIODS;
    }
  }

  if (periods.some((period) => blockedPeriods.some((blocked) => periodsOverlap(period, blocked)))) {
    return PERIOD_ERROR.OVERLAP_REFERENCE;
  }

  return null;
};

export const getWeekErrorCode = (week, blockedPeriodsByDay = {}) => {
  for (const day of WEEK_DAYS) {
    if (!week[day].closed) {
      const errorCode = getPeriodsErrorCode(week[day].periods, blockedPeriodsByDay[day] || []);
      if (errorCode) {
        return errorCode;
      }
    }
  }
  return null;
};

export const buildFollowingPeriod = (lastPeriod, durationHours = 2) => {
  const [hours, minutes] = lastPeriod.to.split(':').map(Number);
  const endHours = hours + durationHours;
  const end = endHours >= 24 ? LAST_START_TIME : `${endHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  return { from: lastPeriod.to, to: end };
};
